import { MainMobileHeaderItem, SecondaryMobileHeaderItem, MenuSettings, PaywallMenuDataMutam } from "./categoryHeaderMutamWrapper"
import { SimpleLinkRenderer } from "../../../../../commonComponents/inline/hyperLink"
import { SiteSimpleImage } from "../../../../../commonComponents/inline/siteSimpleImage";
import CategoryHeaderMutamPaywallSideMenuItems from "./categoryHeaderMutamPaywallSideMenuItems";

interface categoryHeaderMutamSideMenuProps {
    mainItems: MainMobileHeaderItem[]
    secondaryItems: SecondaryMobileHeaderItem[]
    showSideMenu: boolean
    menuSettings: MenuSettings
    domain: string
    oncloseMenu: () => void
    paywallMenuDataMutam: PaywallMenuDataMutam
}

interface menuPopUpState {
    userInput: string
    isSearchInputVisible: boolean
}

export class CategoryHeaderMutamSideMenu extends React.Component<categoryHeaderMutamSideMenuProps, menuPopUpState> {

    constructor(props) {
        super(props)
        this.state = {
            userInput: "",
            isSearchInputVisible: false
        }
    }

    private updateInputValue = (evt) => {
        this.setState({ userInput: evt.target.value });
    }

    private clickAcessibilityBtn = () => {
        window[`EquallyAI`] && window[`EquallyAI`].openToolbox();
        window[`interdeal`] && window[`interdeal`][`a11y`] && window[`interdeal`][`a11y`].openMenu();
    }

    private toggleSearch = () => {
        this.setState({ isSearchInputVisible: !this.state.isSearchInputVisible });
    }

    private search = () => {
        const { userInput } = this.state;

        if (!userInput) {
            return
        }

        const urlTail = "?cx=partner-pub-0047680307646695:9309925491&cof=FORID:10&ie=UTF-8&q="
        const fullUrl = `${this.props.domain}/category/3735${urlTail}${userInput}`

        window.open(fullUrl, '_top');
    }

    private handleInputKeyPress = (evt: React.KeyboardEvent) => {
        if (evt.key === "Enter") {
            this.search();
        }
    }

    render() {
        const { mainItems, secondaryItems, showSideMenu, menuSettings, oncloseMenu,paywallMenuDataMutam} = this.props
        const { termsLink, termsLinkTarget, privacyLink, privacyLinkTarget, followUsText, linkToFb, linkToTw, linkToLinkedIn,showPaywall } = menuSettings
        const { userInput, isSearchInputVisible } = this.state
        const shouldShowFollowUs = linkToFb || linkToTw || linkToLinkedIn;
        const termsLnkTarget = termsLinkTarget.linkOpenType === "new" ? "_blank" : "_top";
        const privacyLnkTarget = privacyLinkTarget.linkOpenType === "new" ? "_blank" : "_top";
        return (
            <div className={`category-header-mutam-side-menu ${showSideMenu ? "show" : "hide"}`}>
                <div className="side-menu-top-bar">
                    <div className="close-btn icon" onClick={isSearchInputVisible ? this.toggleSearch : oncloseMenu}></div>

                    <div className="btns-container">
                        <SimpleLinkRenderer href="/redmail" className="red-mail" title="הדואר האדום">
                            <div className="red-mail-title">הדואר האדום</div>
                            <div className="red-mail-icon icon" />
                        </SimpleLinkRenderer>

                        <div className="separator"></div>

                        <button className="searchBtn icon" onClick={isSearchInputVisible ? this.search : this.toggleSearch} />

                    </div>

                    <input
                        alt="חפש/י"
                        type="text"
                        value={userInput}
                        id="mutamSrchBox"
                        aria-label="חיפוש"
                        placeholder="הקלד/י טקסט כאן"
                        className={`mutamSrchBox ${isSearchInputVisible ? "show" : "hide"}`}
                        onChange={this.updateInputValue}
                        onKeyPress={this.handleInputKeyPress}

                    />
                </div>
                {paywallMenuDataMutam.showPaywallMenu && <CategoryHeaderMutamPaywallSideMenuItems paywallMenuDataMutam={paywallMenuDataMutam} />}
                <div className="navArea">
                    <div className="header-categories-list">
                        <div className="header-items main-items">
                            <div className="items-title">ערוצים ראשיים</div>

                            {mainItems.map(item =>
                                <SimpleLinkRenderer href={item.link} target={item.linkTarget} ariaLabel={item.title} className="header-item main-item" key={item.itemId}>
                                    {item.sideMenuImage && <SiteSimpleImage src={item.sideMenuImage} alt={item.title} title={item.title} width={22} height={22} />}
                                    <div className="item-title">{item.title}</div>
                                </SimpleLinkRenderer>
                            )}
                        </div>

                        <div className="separator"></div>

                        <div className="header-items secondary-items">
                            <div className="items-title">עוד בכלכליסט</div>

                            {secondaryItems.map(item =>
                                <SimpleLinkRenderer href={item.link} target={item.linkTarget} ariaLabel={item.title} className="header-item secondary-item" key={item.itemId}>
                                    <div className="item-title">{item.title}</div>
                                </SimpleLinkRenderer>
                            )}
                        </div>

                        <div className="separator"></div>

                        <div className="header-items contact-items">
                            <div className="items-title">יצירת קשר</div>

                            <SimpleLinkRenderer href="mailto:kavham@calcalist.co.il?subject=כלכליסט שירות לקוחות" className="header-item space-between" title="כתבו לנו">
                                <span className="item-title">כתבו לנו</span>
                                <div className="pencil-icon icon" />
                            </SimpleLinkRenderer>

                            <SimpleLinkRenderer href="/redmail" className="header-item space-between" title="הדואר האדום">
                                <span className="item-title red-mail-title">הדואר האדום</span>
                                <div className="red-mail-icon icon" />
                            </SimpleLinkRenderer>
                        </div>

                        <div className="separator"></div>

                        <div className="header-items menu-settings">
                            <SimpleLinkRenderer href={termsLink} target={privacyLnkTarget} ariaLabel={'תנאי שימוש'} className="header-item">
                                <div className="item-title">תנאי שימוש</div>
                            </SimpleLinkRenderer>

                            <SimpleLinkRenderer href={privacyLink} target={termsLnkTarget} ariaLabel={'מדיניות פרטיות'} className="header-item">
                                <div className="item-title">מדיניות פרטיות</div>
                            </SimpleLinkRenderer>

                            <div id="INDmenu-btn3" className="header-item space-between" title="אתר נגיש" accessKey="m" aria-labelledby="INDbtnTooltip" role="button" onClick={this.clickAcessibilityBtn}>
                                <div className="item-wrapper">
                                    <div className="accessability-icon icon" />
                                    <span className="item-title">נגישות</span>
                                </div>

                                <div className="arrow-icon icon"></div>
                            </div>
                        </div>

                        {shouldShowFollowUs && <div className="separator"></div>}
                        
                        {shouldShowFollowUs &&
                            <div className="header-items follow-items">
                                <div className="items-title">{followUsText}</div>

                                <div className="header-item">
                                    {linkToFb &&
                                        <SimpleLinkRenderer href={linkToFb} ariaLabel={'פרופיל פייסבוק'}>
                                            <div className="icon fb-icon"></div>
                                        </SimpleLinkRenderer>}

                                    {linkToTw &&
                                        <SimpleLinkRenderer href={linkToTw} ariaLabel={'פרופיל טוויטר'}>
                                            <div className="icon tw-icon"></div>
                                        </SimpleLinkRenderer>}

                                    {linkToLinkedIn &&
                                        <SimpleLinkRenderer href={linkToLinkedIn} ariaLabel={'פרופיל לינקדאין'}>
                                            <div className="icon li-icon"></div>
                                        </SimpleLinkRenderer>}
                                </div>
                            </div>}
                    </div>
                </div>
            </div>
        )
    }
}
